export const deliverymethod = {
    title: 'ประเภทการจัดส่ง',
    delivery: 'เดลิเวอรี่',
    no_delivery: 'ไม่มีเดลิเวอร์รี่',
    self_pickup: 'รับกลับบ้าน / ทานที่ร้าน',
    no_self_pickup: 'ไม่มีรับกลับบ้าน / ทานที่ร้าน',
    delivery_to: 'จัดส่งที่',

    start_your_order: 'เริ่มสั่งอาหาร',
    please_select_address: 'เลือกที่อยู่ของคุณ',
    please_select_branch: 'เลือกสาขาที่รับอาหาร',

    select_add: "เลือก / เพิ่ม",
    if_you_change: "หากคุณทำการเปลี่ยนที่อยู่ หรือเลือกสาขาใหม่ ราคาค่าอาหารอาจมีการเปลี่ยนแปลง",

    select_time: 'เลือกเวลารับอาหาร',
    now: 'ตอนนี้',
    wait_cooked: '(รออาหารประมาณ 30 นาที)',

    apply: 'สั่งอาหาร',

    select_title: "เลือกสาขา",
    nearby: "ใกล้คุณ",
    select_branch: "เลือกสาขา",
    pickup_at: "รับที่สาขา",
    takeaway: "รับกลับบ้าน",
    dinein: "ทานที่ร้าน",
    at_specific_time: "ระบุเวลา",

    branch_closed: "(ปิดร้านชั่วคราว)",
    popup_confirm_clear: {
        msg: "เปลี่ยนวิธีการสั่งซื้อ? (เดลิเวอรี่/รับที่ร้าน) คุณกำลังจะเปลี่ยนวิธีการสั่งซื้อ เราต้องล้างของในตะกร้าคุณก่อน",
        ok: "ยืนยัน",
        cancel: "ยกเลิก"
    },
    out_of_area: 'อยู่นอกพื้นที่การจัดส่ง',
};